"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferToJSON = exports.OfferFromJSONTyped = exports.OfferFromJSON = exports.instanceOfOffer = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the Offer interface.
 */
function instanceOfOffer(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfOffer = instanceOfOffer;
function OfferFromJSON(json) {
    return OfferFromJSONTyped(json, false);
}
exports.OfferFromJSON = OfferFromJSON;
function OfferFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'adAccountId': !(0, runtime_1.exists)(json, 'ad_account_id') ? undefined : json['ad_account_id'],
        'offerId': !(0, runtime_1.exists)(json, 'offer_id') ? undefined : json['offer_id'],
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'expiry': !(0, runtime_1.exists)(json, 'expiry') ? undefined : (new Date(json['expiry'])),
        'adSetId': !(0, runtime_1.exists)(json, 'ad_set_id') ? undefined : json['ad_set_id'],
        'createdBy': !(0, runtime_1.exists)(json, 'created_by') ? undefined : json['created_by'],
        'offerAmountMicros': !(0, runtime_1.exists)(json, 'offer_amount_micros') ? undefined : json['offer_amount_micros'],
        'currency': !(0, runtime_1.exists)(json, 'currency') ? undefined : json['currency'],
    };
}
exports.OfferFromJSONTyped = OfferFromJSONTyped;
function OfferToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'ad_account_id': value.adAccountId,
        'offer_id': value.offerId,
        'name': value.name,
        'expiry': value.expiry === undefined ? undefined : (value.expiry.toISOString()),
        'ad_set_id': value.adSetId,
        'created_by': value.createdBy,
        'offer_amount_micros': value.offerAmountMicros,
        'currency': value.currency,
    };
}
exports.OfferToJSON = OfferToJSON;
